import React from 'react'
import { HelmetProvider } from 'react-helmet-async'
import { Navigate, Route, Routes } from 'react-router-dom'

import AgentChallengePage from './pages/AgentChallengePage'
import CommentPage from './pages/CommentPage'
import HomePage from './pages/HomePage'
import InvitePage from './pages/InvitePage'
import ResultsPage from './pages/ResultsPage'
import VerifyPage from './pages/VerifyPage'
import VerifyWidgetPage from './pages/VerifyWidgetPage'

function App() {
  return (
    <HelmetProvider>
      <Routes>
        {/* Turnstile verification pages - loaded in mobile WebView */}
        <Route path="/verify" element={<VerifyPage />} />
        <Route path="/verify-widget" element={<VerifyWidgetPage />} />

        {/* Universal Link routes - for users without app installed */}
        <Route path="/invite/:code" element={<InvitePage />} />
        <Route path="/comment/:code" element={<InvitePage />} />

        {/* Forum routes */}
        <Route path="/f/:forumName" element={<ResultsPage />} />
        <Route path="/f/:forumName/:commentId" element={<CommentPage />} />
        <Route path="/f/:forumName/results" element={<Navigate to=".." replace />} />

        {/* Agent challenge deep link */}
        <Route path="/a/:agentId" element={<AgentChallengePage />} />

        {/* Home route */}
        <Route path="/" element={<HomePage />} />
      </Routes>
    </HelmetProvider>
  )
}

export default App
